module.exports = "https://static.wmbcdn.com/uniweb/images/986b81596b3942964d69b086261f433b.svg";